<template>
    <TabHeader  />    
      <v-card  elevation="16" variant="outlined" class="mx-auto my-8">
          <v-card-item>
        
     <v-card-text> 
  <v-container style="text-align: right;color:#0a42da;font-weight: bold;">
    {{nomPatient}}
  </v-container>
  <v-container v-if="creation">
    <v-row>
      <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined"        type="datetime-local" label="Date de prise" v-model="localdata.datePrise" ></v-text-field>
   </v-col>
  
      <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined"  type="number" label="Température" v-model="localdata.temperature" ></v-text-field>
   </v-col>
   <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined"  type="number" label="Pools" v-model="localdata.pouls" ></v-text-field>
</v-col>
   
      <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined"  type="number" label="Tension systolique" v-model="localdata.tensionSystolique" ></v-text-field>
     </v-col>
     <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined"  type="number" label="Tension diastolique" v-model="localdata.tensionDiastolique" ></v-text-field>
</v-col>
  
      <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined" type="number" label="EVA" v-model="localdata.eva" ></v-text-field>
      </v-col>

    </v-row>
    <v-row>
      <v-switch
        v-model="localdata.vomissement"
        hide-details
        inset  
        color="primary"   
       label="Vomissement"
  ></v-switch>
  <v-switch
        v-model="localdata.nausee"
        hide-details
        inset  
        color="primary"   
       label="Nausée"
  ></v-switch>
  <v-switch
        v-model="localdata.constipation"
        hide-details
        inset  
        color="primary"   
       label="Constipation"
  ></v-switch>
  <v-switch
        v-model="localdata.douleur"
        hide-details
        inset  
        color="primary"   
       label="Douleur"
  ></v-switch>
  <v-switch
        v-model="localdata.diarrhe"
        hide-details
        inset  
        color="primary"   
       label="Diarrhée"
  ></v-switch>
    </v-row>



<v-row justify="center" >
      <v-btn @click="ajouter()" 
      color="blue-darken-4"
         class="text-none ms-4 text-white">Valider</v-btn><v-btn @click="creation=false" :to="'/constantes/'+getId()"  color="red-darken-4"
         class="text-none ms-4 text-white">Annuler</v-btn>
    </v-row>  
  </v-container >
  <v-container v-if="!creation">
    <v-row  elevation="16" variant="outlined">
      <v-btn @click="create()"  color="#0a42da"
         class="text-none ms-1 text-white"><v-icon
        class="me-2"
        elevation="16" variant="outlined"
      >
      mdi-plus</v-icon>Nouvelle constante</v-btn>
    </v-row>
   
    <v-row>
      <v-data-table 
      style="border-color: #0a42da;border-style: solid;border-width: 0.1px;"
      :headers="headers" 
      :items="listdata" 
      v-model:sort-by="sortBy"
      no-data-text="Pas de données disponible"
      items-per-page-text="Nombre d'elements par page"    
      >
      <template v-slot:[`item.datePrise`]="{ item }">       
        {{ $formatDate(item.datePrise) }}
      </template>
      <template v-slot:[`item.actions`]="{ item,index }">
      <v-btn @click="localdata=item; creation=true" flat route :to="'/constantes/'+getId()+'/'+item.id">
      <v-icon
        size="small"
        class="me-2"
        
      >
        mdi-pencil
      </v-icon>
      </v-btn>
      <v-btn  flat  @click="deleteItem(item,index)" >
      <v-icon
        size="small"
       
      >
        mdi-delete
      </v-icon>
      </v-btn>
    </template>
      </v-data-table>
    </v-row>
  </v-container>
  </v-card-text>
  </v-card-item>
  </v-card>

</template>

<script>
import http from '../../http.js'
import TabHeader from './TabHeader.vue'


export default {
  components: { TabHeader },
  name: 'App',

data: () => ({
      form: false,
      email: null,
      password: null,
      creation:false,
      loading: false,
      nomPatient:null,
      localdata:{"datePrise":null},

      listdata:[],
      sortBy:[{key:"datePrise",order:"desc"}],
      headers:[{"title":"Date","key":"datePrise","Sortable":true},{"title":"Température","key":"temperature"},{"title":"Pouls","key":"pouls"},{ title: 'Actions', key: 'actions', sortable: false }]

    }),
  computed: {
    localdata1: {
        get() {
            return this.data
        },
        set(newValue) {
            this.$emit('update:data', newValue)
        },
    },
},

    mounted(){
        this.list();
       this.nomPatient= localStorage.getItem("nomPatient");
    },
    methods:{
      IsNotView(){
       
        this.$route.name!='viewConstante'
      },
        ajouter(){
      
            http.put('/api/addConstante/'+this.$route.params.id, JSON.stringify(this.localdata),{
        headers: {
            'Content-Type': 'application/json',
        }
    })
     .then(response => {
      console.log('File uploaded successfully:'+response.data);
      this.list()
      this.creation =false
      this.localData={}

     })
    .catch(error => {
      alert(JSON.stringify(error))
      console.error('Error uploading file:', error);
  })
        },
        list(){

        http.get('/api/getConstante/'+this.$route.params.id).then(res=>{this.listdata=res.data;})


      },
    getId(){ 
            return this.$route.params.id;
        },

    create(){
      this.creation = true;
      this.localdata = {};
      this.localdata.datePrise =new Date();
    },
    isAdmin(){
            let user =JSON.parse(localStorage.getItem("user"));
               return  user.profil==='admin';
        },
    async deleteItem(item,index){      
          if(confirm('Etes vous sur de la suppresion de cette constante ?')){
           await http.delete("/api/constante/"+this.getId()+"/"+item.id)
            this.listdata.splice(index, 1);
      }
      

    }
    }
    
    

 
}

</script>